import { render } from "./MissedPayments.vue?vue&type=template&id=a0fc8118&scoped=true"
const script = {}

import "./MissedPayments.vue?vue&type=style&index=0&id=a0fc8118&scoped=true&lang=css"

import exportComponent from "/home/runner/work/helixpay-website/helixpay-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0fc8118"]])

export default __exports__